import { useEffect, useState } from "react";

/** An object URL for a fetched file, revoked when the file changes or the component unmounts. */
export function useObjectURL(blob: Blob | undefined): string | null {
  const [url, setURL] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) {
      setURL(null);
      return;
    }
    const next = URL.createObjectURL(blob);
    setURL(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);
  return url;
}
